/* @ngInject */
const editDispositionModal = (
  $uibModal,
  wagonRequest,
  utils,
  toaster,
  wagonFormat,
) => {
  const self = {}

  self.open = (_wagon, _wagons) => {
    return $uibModal.open({
      template: require('./editDisposition.html'),
      resolve: {
        wagon: () => {
          return _wagon
        },
        wagons: () => {
          return _wagons
        },
      },
      /* @ngInject */
      controller: ($scope, $uibModalInstance, wagon, wagons) => {
        $scope.myWagon = wagonFormat.user(wagon)

        $scope.submit = async (_wagon) => {
          try {
            const response = await wagonRequest.update(wagonFormat.server($scope.myWagon))
            utils.updateFromArray(wagons, response.wagon)
            toaster.message(response.message, response.color)
            $uibModalInstance.close()
          } catch (error) {
            toaster.error(error)
            $uibModalInstance.close()
          }
        }

        $scope.cancel = () => {
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default editDispositionModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/editDisposition.modal.js